import { api } from '../utils'
import { notificate } from './notification'
import { beforeSend, afterResponse } from './'

const identifier = 'model'

export const loadModels = (brandId, token) => {
  return dispatch => {
    dispatch(beforeSend(identifier))
    const params = { brand_id: brandId }
    api.get('admin/models', params, token)
      .then(result => {
        if (result.success) {
          dispatch({
            type: 'SET_MODELS',
            data: result.data
          })
        }
        dispatch(afterResponse(identifier))
      })
      .catch(error => {
        dispatch(notificate(error.message, 'error'))
        dispatch(afterResponse(identifier))
      })
  }
}

export const createModel = (data, token) => {
  return dispatch => {
    dispatch(beforeSend(identifier))
    api.post('admin/models', data, token)
      .then(result => {
        if (result.success) {
          dispatch({
            type: 'SET_MODEL',
            data: result.data
          })
        } else {
          dispatch(notificate(result.message, 'error'))
        }
        dispatch(afterResponse(identifier))
      })
      .catch(error => {
        dispatch(notificate(error.message, 'error'))
        dispatch(afterResponse(identifier))
      })
  }
}

export const updateModel = (data, token) => {
  return dispatch => {
    dispatch(beforeSend(identifier))
    api.put(`admin/models/${data.id}`, data, token)
      .then(result => {
        if (result.success) {
          dispatch({
            type: 'UPDATE_MODEL',
            data: result.data
          })
        } else {
          dispatch(notificate(result.message, 'error'))
        }
        dispatch(afterResponse(identifier))
      })
      .catch(error => {
        dispatch(notificate(error.message, 'error'))
        dispatch(afterResponse(identifier))
      })
  }
}

export const deleteModel = (id, token) => {
  return dispatch => {
    dispatch(beforeSend(identifier))
    api.delete(`admin/models/${id}`, {}, token)
      .then(result => {
        if (result.success) {
          dispatch({
            type: 'DELETE_MODEL',
            id
          })
        } else {
          dispatch(notificate(result.message, 'error'))
        }
        dispatch(afterResponse(identifier))
      })
      .catch(error => {
        dispatch(notificate(error.message, 'error'))
        dispatch(afterResponse(identifier))
      })
  }
}

export const clearModels = () => {
  return dispatch => {
    dispatch({
      type: 'SET_MODELS',
      data: []
    })
  }
}
